export default __webpack_public_path__ + "static/media/shop6.6a4bb804.jpg";